export const isShopTheLookOpen = (state) => state.shopTheLook.open;
export const getShopTheLookTitle = (state) => state.shopTheLook.title;
export const getCurrentShopTheLookItems = (state) => state.shopTheLook.items;


// WEBPACK FOOTER //
// ./src/selectors/shopTheLook.js